import React from 'react';
import Box from '@mui/material/Box';
import DragIcon from 'assets/images/drag.svg';
import { palette } from 'theme/palette';
import { styled } from '@mui/material/styles';
import { ColumnConfiguration } from 'src/common/components/Sim/Inventory/constants/columnConfigurationsConstants';
import {
  TableCellContent,
  TableCellDataBox,
} from 'src/common/components/ConfigurableTable/Components/Header/HeaderCell';
import { HeaderField } from 'src/common/components/ConfigurableTable/Components/Header/HeaderField';
import { SortableHeaderIdicator } from 'src/common/components/ConfigurableTable/Components/Header/SortableHeaderIdicator';
import { pxToRem } from 'src/common/utils/fonts';

type HeaderCellProps = {
  primaryText?: string;
  secondaryText?: string;
  column: ColumnConfiguration;
};

const DragBox = styled(Box)(({ theme }) => ({
  height: theme.spacing(40),
  backgroundColor: `${palette.grey[100]}`,
  position: 'absolute',
  right: 0,
  top: theme.spacing(1),
  paddingTop: theme.spacing(11),
  width: theme.spacing(30),
  cursor: 'move',
  marginRight: theme.spacing(8),
}));

export const HeaderCell: React.FC<HeaderCellProps> = ({ primaryText, secondaryText, column }) => {
  const primaryFieldSortable = column.sortable;
  const secondartFieldSortable = column.children[0]?.sortable || false;

  return (
    <TableCellContent>
      <TableCellDataBox
        data-testid="tableHeaderPrimary"
        sortable={primaryFieldSortable}
        align="left"
      >
        {primaryFieldSortable && (
          <SortableHeaderIdicator field={column.name} data-testid="primarySortingIndicator" />
        )}
        <HeaderField>{primaryText}</HeaderField>
      </TableCellDataBox>
      <TableCellDataBox
        data-testid="tableHeaderSecondary"
        sortable={secondartFieldSortable}
        align={'left'}
      >
        {secondartFieldSortable && (
          <SortableHeaderIdicator
            field={column.children[0].name}
            data-testid="secondarySortingIndicator"
          />
        )}
        <HeaderField variant="secondary">{secondaryText}</HeaderField>
      </TableCellDataBox>

      <DragBox className="dragBox">
        <DragIcon width={pxToRem(10)} height={pxToRem(16)} role="img" data-testid="drag-icon" />
      </DragBox>
    </TableCellContent>
  );
};
